<nz-form-label class="lbl-radio" [attr.nzFor]="fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup" class="form-control-radio">
    <nz-radio-group [(ngModel)]="radioValue" [id]="fieldCode" (ngModelChange)="changeRadioValue()" [attr.data-value]="radioValue"
        [formControlName]="formFieldInfo.fieldCode">
        <ng-container *ngFor="let option of customfieldOptionList">
            <label nz-radio [nzValue]="option.optionCode" 
                [class]="addClass(option.fieldOptionConfig)"
                [attr.data-optionvalue]="option.optionValue" [attr.data-optioncode]="option.optionCode"
                class="label-group" id="multi{{fieldCode}}-{{option.optionCode}}">{{option.optionValue}}</label>
            <input nz-input id="{{fieldCode}}-{{option.optionCode}}_INPUT" *ngIf="option.allowInput"
                (focus)="focusInput(option)" class="allow-input" (change)="keydownValidateAllowInput(option)"
                (keydown)="keydownValidateAllowInput(option)" (keypress)="keydownValidateAllowInput(option)"
                (keyup)="keydownValidateAllowInput(option)" nzSize="large"
                formControlName="{{fieldCode}}-{{option.optionCode}}_INPUT" />
        </ng-container>
    </nz-radio-group>
</nz-form-control>

<div *ngIf="itemListByValue.length > 0" nz-row class="row sub-items" [hidden]="isHiddenSubItem" id="{{fieldCode}}">
    <span *ngFor="let c of itemListByValue" [hidden]="c.isHidden" [ngClass]="getCol(c)">
        <div *ngIf="c.fieldTypeCode == 'TITLE'">
            <app-component-title [formFieldInfo]="c" class="directive-component"></app-component-title>
        </div>
        <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT'">
            <app-component-text [formFieldInfo]="c" [formGroup]="formGroup" 
                id="{{c.fieldCode}}"
                [ngClass]="fieldCode"
                [attr.query]="fieldCode"
                [formData]="formData" class="directive-component">
            </app-component-text>
        </nz-form-item>

        <!--Binding du lieu cho truong hop form con cua radio-->
        <!-- <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT' && flag">
            <app-component-text [formFieldInfo]="c" id="TABLE_{{c.fieldCode}}" [formGroup]="formGroup" [attr.query]="fieldCode" [ngClass]="fieldCode" [formData]="formData" class="directive-component">
            </app-component-text>
        </nz-form-item> -->
        <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE_COMPLEX'">
            <app-component-table-complex (tableEmit)="tableOutput($event)" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" [formData]="formData" [formData]="formData"
                class="directive-component">
            </app-component-table-complex>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER'">
            <app-component-number id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup" [attr.query]="fieldCode" [ngClass]="fieldCode" [formData]="formData"
                class="directive-component">
            </app-component-number>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'TEXTAREA'">
            <app-component-textarea id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode" class="directive-component">
            </app-component-textarea>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'DATE'">
            <app-component-date id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode" [formGroup]="formGroup" [formData]="formData"
                class="directive-component">
            </app-component-date>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'DATETIME'">
            <app-component-datetime id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode" class="directive-component">
            </app-component-datetime>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'SELECTLIST_SINGLE'">
            <app-component-single-select id="{{c.fieldCode}}" [formFieldInfo]="c" class="directive-component"
                (selectEmit)="selectOutput($event)" [inputData]="selectChildData" [formGroup]="formGroup"
                [ngClass]="fieldCode"
                [attr.query]="fieldCode"
                [formData]="formData">
            </app-component-single-select>
        </nz-form-item>
        
        <!--Binding du lieu cho truong hop form con cua radio-->
        <!-- <nz-form-item *ngIf="c.fieldTypeCode == 'SELECTLIST_SINGLE' && flag">
            <app-component-single-select id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" class="directive-component"
                (selectEmit)="selectOutput($event)" [inputData]="selectChildData" [formGroup]="formGroup"
                [ngClass]="fieldCode"
                [attr.query]="fieldCode"
                [formData]="formData">
            </app-component-single-select>
        </nz-form-item> -->
        <nz-form-item *ngIf="c.fieldTypeCode == 'SPACE'">
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'MULTIPLE_CHOICE'">
            <app-component-multiple-choice id="{{c.fieldCode}}" [formFieldInfo]="c"
                class="multi-choice-control directive-component"
                [ngClass]="fieldCode"
                [attr.query]="fieldCode"
                [inputCustomfieldOptionList]="getMultipleChoiceCustomfieldList(c)" [itemList]="getSubItemsList(c)"
                [listFormFieldInfo]="listFormFieldInfo" [formGroup]="formGroup" [formData]="formData">
            </app-component-multiple-choice>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'RADIO_BUTTON'">
            <app-component-radiobutton id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                [listFormFieldInfo]="listFormFieldInfo" class="radio-button-control directive-component"
                [ngClass]="fieldCode"
                [attr.query]="fieldCode"
                [itemList]="getSubItemsList(c)" [formData]="formData">
            </app-component-radiobutton>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'LABEL'">
            <app-component-label id="{{c.fieldCode}}" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" class="directive-component">
            </app-component-label>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'CHECK_BOX'">
            <app-component-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" class="directive-component">
            </app-component-checkbox>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER_CURRENCY'">
            <app-component-number-currency id="{{c.fieldCode}}" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" class="directive-component">
            </app-component-number-currency>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT_CHECK_BOX'">
            <app-component-text-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" class="directive-component">
            </app-component-text-checkbox>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'DATE_CHECK_BOX'">
            <app-component-date-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [attr.query]="fieldCode" [ngClass]="fieldCode" class="directive-component">
            </app-component-date-checkbox>
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE'">
        </nz-form-item>
        <nz-form-item *ngIf="c.fieldTypeCode == 'UPLOAD_FILE'">
        </nz-form-item>
    </span>
</div>